

















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import moment from "moment";
import { HogarSancion } from '../../models/hogar/alertas.model';
import Helpers from '@/helpers/helper';
@Component
export default class HogarSancionesTable extends GenericBTable<
  HogarSancion
> {
  @Prop() public title!: string;
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public hogarId!: string;
  created() {
    this.setupTable();
  }
  setupTable() {
    this.tableConfig.controller = this.controller || "hogarsancion";
    //this.tableConfig.loading = false;
    this.tableConfig.whereParams = this.getWhereParams();
    //this.tableConfig.resource = "alertas";
    this.tableConfig.activeActions = false;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.rowClass = (row: HogarSancion, index: number) => row.vigente && "is-warning";
    this.formatColumns();
  }
  get vigentes(){
    return this.tableConfig.data.filter(x=> x.vigente).length;
  }
  onLoadData(response:any){
  this.$emit('vigentes', this.vigentes)
}
  getWhereParams() {
    let result = [];
    if (this.hogarId) result.push(`hogarId="${this.hogarId}"`);
    return result.join("&");
  }
  formatColumns() {
    let causaSancion = new BTableColumn("causaSancion", "Categoría");
    let mes = new BTableColumn("mes", "Mes");
    mes.type = BTableColumnType.Custom;
    mes.customFilter = (value:string) => Helpers.Filters.NumAMes(value);
    let ano = new BTableColumn("ano", "Año");
    let vigencia = new BTableColumn("vigencia", "Vigencia");
    vigencia.type = BTableColumnType.Custom;
    vigencia.customFilter = (val:any)=> val === 1 ? `${val} mes` : `${val} meses`;
    let estado = new BTableColumn("estado", "Estado");
    let fecha = new BTableColumn("fecha", "Fecha");
    fecha.type = BTableColumnType.Date;
    this.tableConfig.insertColumns(causaSancion, mes, ano,vigencia,estado, fecha);
  }
  @Watch("hogarId", { immediate: true })
  onhogarIdChange(value: number | undefined | null) {
    if (!value) {
      return;
    }
    this.tableConfig.whereParams = this.getWhereParams();
    if (this.tableConfig.reload) this.tableConfig.reload();
  }
}
